import { frontendURL } from '../../../../helper/URLHelper';
import { FLEX_TEMPLATE_PERMISSIONS } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
const FlexTemplatesIndex = () => import('./Index.vue');
const FlexTemplateEditor = () => import('./FlexTemplateEditor.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flex-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'flex_templates_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'flex_templates_list',
          meta: {
            permissions: ['administrator', FLEX_TEMPLATE_PERMISSIONS],
          },
          component: FlexTemplatesIndex,
        },
        {
          path: 'new',
          name: 'flex_templates_new',
          meta: {
            permissions: ['administrator', FLEX_TEMPLATE_PERMISSIONS],
          },
          component: FlexTemplateEditor,
        },
        {
          path: ':templateId/edit',
          name: 'flex_templates_edit',
          meta: {
            permissions: ['administrator', FLEX_TEMPLATE_PERMISSIONS],
          },
          component: FlexTemplateEditor,
        },
      ],
    },
  ],
};
